import { templateSensor } from '../../base/view/template';

export const templateO365Mail = document.createElement('template');

export const sensorFields = `
<gz-form-field label="" id="o365_mail_applicationid" required stacked>
  <gz-input gz-form-input="" type="text" ></gz-input>
  <gz-input-error></gz-input-error>
</gz-form-field>
<gz-form-field label="" id="o365_mail_tenantid" required stacked>
  <gz-input gz-form-input="" type="text" ></gz-input>
  <gz-input-error></gz-input-error>
</gz-form-field>
<gz-form-field label="" id="o365_mail_client_secret" required stacked>
  <gz-input gz-form-input="" type="password" ></gz-input>
  <gz-input-error></gz-input-error>
</gz-form-field>`;

templateO365Mail.innerHTML = `${templateSensor
  .replace('{sensorFields}', sensorFields)
  .replace('{sensorDataReuse}', '')}`;
